<template>
  <div id="tickets">
    <Loader :active="loading" :full="false"></Loader>

    <div class="columns dashboard-heading">
      <div class="column">
        <div class="level is-mobile">
          <div class="level-left">
            <h1 class="title has-text-primary">
              Bienvenido, {{ this.$store.getters["getSession"]["name"] }}
            </h1>
          </div>
          <div class="level-right">
            <button
              type="button"
              class="dashboard-notices-button"
              data-tooltip="AVISOS Y NOTIFICACIONES"
              aria-label="Abrir avisos y notificaciones"
              @click="openNotices"
            >
              <i class="fas fa-bell" aria-hidden="true"></i>
              <span class="dashboard-notices-dot" aria-hidden="true"></span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-summary">
      <router-link v-if="canViewTickets && summary.tickets !== null" to="/consultas" class="summary-card">
        <span class="summary-icon"><i class="fas fa-comments" aria-hidden="true"></i></span>
        <span class="summary-copy">
          <strong>{{ summary.tickets }}</strong>
          <small>Consultas pendientes</small>
        </span>
        <span class="summary-arrow" aria-hidden="true">›</span>
      </router-link>
      <router-link v-if="canViewSales && summary.sales !== null" to="/ventas" class="summary-card">
        <span class="summary-icon"><i class="fas fa-user-plus" aria-hidden="true"></i></span>
        <span class="summary-copy">
          <strong>{{ summary.sales }}</strong>
          <small>Ventas pendientes</small>
        </span>
        <span class="summary-arrow" aria-hidden="true">›</span>
      </router-link>
      <router-link v-if="canViewInvoices && summary.invoices !== null" :to="{ path: '/prestadores', query: { tab: 'facturacion' } }" class="summary-card">
        <span class="summary-icon"><i class="fas fa-file-invoice-dollar" aria-hidden="true"></i></span>
        <span class="summary-copy">
          <strong>{{ summary.invoices }}</strong>
          <small>Facturas pendientes</small>
        </span>
        <span class="summary-arrow" aria-hidden="true">›</span>
      </router-link>
    </div>

    <div class="columns dashboard-widgets">
      <!-- Columna para tickets  -->

      <div
        class="column dashboard-widget"
        v-if="canViewTickets"
      >
        <h2 class="title is-4">Últimas consultas asignadas</h2>

        <div v-if="Ticket.length > 0">
          <div v-for="ticket in Ticket" :key="ticket.id">
            <TicketCard
              :id="ticket.id"
              :link="`/consultas/id/${ticket.id}`"
              :title="ticket.contact ? ticket.contact.fullname : 'Consulta sin contacto'"
              :description="ticket.departament ? ticket.departament.name : ''"
              :status="ticket.status"
            />
          </div>
          <router-link
            to="/consultas"
            class="dashboard-view-all"
          >
            Ver Todas
          </router-link>
        </div>
        <div v-else><h5>No hay consultas asignadas</h5></div>
      </div>

      <!-- Columna para ventas -->
      <div
        class="column dashboard-widget"
        v-if="canViewSales"
      >
        <h2 class="title is-4">Últimas ventas asignadas</h2>
        <div v-if="Sales.length > 0">
          <div v-for="sale in Sales" :key="sale.id">
            <SaleCard
              :sale="{
                id: sale.id,
                color: sale.color,
                status: sale.status,
                contact_fullname: sale.contact ? sale.contact.fullname : 'Venta sin contacto',
                ticket_id: sale.ticket_id,
                province: sale.contact ? sale.contact.province : '',
                phone: sale.contact ? sale.contact.celphone : '',
              }"
              :link="`/ventas/id/${sale.id}`"
            />
          </div>
          <router-link
            to="/ventas"
            class="dashboard-view-all"
          >
            Ver Todas
          </router-link>
        </div>
        <div v-else><h5>No hay ventas asignadas</h5></div>
      </div>

      <!-- Columna para prestaciones -->
      <div
        class="column dashboard-widget"
        v-if="canViewInvoices"
      >
        <h2 class="title is-4">Últimas facturas de prestadores</h2>
        <div v-for="invoice in Invoices" :key="invoice.id">
          <InvoiceCard
            :id="invoice.id"
            :link="`/prestadores`"
            :title="invoice.provider ? invoice.provider.comercial_name : 'Prestador sin datos'"
            :description="invoice.provider ? invoice.provider.province : ''"
            :status="invoice.state"
            :phone="invoice.provider.phone"
          />
        </div>
        <router-link
          to="/prestadores"
          class="dashboard-view-all"
        >
          Ver Todas
        </router-link>
      </div>
    </div>
    <br />
    <div class="columns">
      <div class="column is-fullwidth">
        <h2 class="title is-4">ACCESOS DIRECTOS</h2>
        <div class="button-container">
          <a
            href="https://prestadores.osfatun.com.ar/"
            class="button"
            target="_blank"
            >CARTILLA DE PRESTADORES</a
          >
          <router-link
            to="/cuotas-y-minimos"
            class="button"
            target="_blank"
            >CUOTAS Y MÍNIMOS</router-link
          >
          <router-link
            to="/datos-y-unidades"
            class="button"
            target="_blank"
            >DATOS Y UNIDADES</router-link
          >
          <a
            href="https://www.osfatun.com.ar/vademecum"
            class="button"
            target="_blank"
            >VADEMÉCUM</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Loader from "./Loader.vue";
import Search from "./Search.vue";
import TicketCard from "./Ticket-card-home.vue";
import SaleCard from "./Sale-card-home.vue";
import InvoiceCard from "./Invoice-card-home.vue";

const COLOR = {
  low: "success",
  medium: "warning",
  high: "danger",
};
const STATUS = {
  "not attended": "No atendido",
  open: "Abierto",
  closed: "Cerrado",
  "in process": "En proceso",
};
const ORIGIN = {
  whatsapp: {
    type: "is-success",
    pack: "fab",
    icon: "whatsapp",
    name: "Whatsapp",
  },
  messenger: {
    type: "is-info",
    pack: "fab",
    icon: "facebook-messenger",
    name: "Messenger",
  },
  instagram: {
    type: "is-light",
    pack: "fab",
    icon: "instagram",
    name: "Instagram",
  },
  web: {
    type: "is-light",
    pack: "fas",
    icon: "globe",
    name: "Web",
  },
  crm: {
    type: "is-light",
    pack: "fas",
    icon: "globe",
    name: "Crm",
  },
  email: {
    type: "is-light",
    pack: "far",
    icon: "envelope",
    name: "Email",
  },
  delegacion: {
    type: "is-light",
    pack: "fas",
    icon: "globe",
    name: "Delegación",
  },
  "call center": {
    type: "is-light",
    pack: "fas",
    icon: "globe",
    name: "Call Center",
  },
  referido: {
    type: "is-light",
    pack: "fas",
    icon: "globe",
    name: "Referido",
  },
};
export default {
  name: "Tickets",
  components: {
    Loader,
    Search,
    TicketCard,
    SaleCard,
    InvoiceCard,
  },
  data() {
    return {
      loading: false,
      is_marketer: localStorage.getItem("name"),
      summary: { tickets: null, sales: null, invoices: null },
      Ticket: [],
      Sales: [],
      Invoices: [],
      filter: {
        search: "",
        activeTab: "Todos",
        departament: "",
      },
      tickets: {
        data: [],
        total: 0,
        order: "desc",
        page: 1,
        lastPage: "",
        perPage: 10,
      },
    };
  },
  methods: {
    openNotices() {
      this.$store.commit("setDashboardNotices", true);
    },
    async fetchSummary() {
      try {
        const query = await this.$repositories.dashboard.summary();
        this.summary = { ...this.summary, ...query.data };
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTickets() {
      this.loading = true;
      try {
        const query = await this.$repositories.tickets.indexHome();

        if (Array.isArray(query.data.ticket) && query.data.ticket.length > 0) {
          this.Ticket = query.data.ticket;
          this.Ticket.forEach((ticket) => {
            ticket.status = STATUS[ticket.status] || ticket.status;
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async fetchSales() {
      this.loading = true;
      try {
        const query = await this.$repositories.sales.indexhome();
        this.Sales = Array.isArray(query.data.sales) ? query.data.sales : [];
        this.Sales.forEach((sale) => {
          sale.status = STATUS[sale.status];
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async fetchInvoices() {
      this.loading = true;
      try {
        const query = await this.$repositories.providers.invoiceListHome();
        this.Invoices = Array.isArray(query.data) ? query.data : [];
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapState(["toggle"]),
    canViewTickets() {
      return this.$hasPermission("consultas.ver");
    },
    canViewSales() {
      return this.$hasPermission("ventas.ver");
    },
    canViewInvoices() {
      return this.$hasPermission("prestadores.ver");
    },
  },
  created() {
    this.fetchSummary();
    if (this.canViewInvoices) this.fetchInvoices();
    if (this.canViewSales) this.fetchSales();
    if (this.canViewTickets) this.fetchTickets();
    this.$EventBus.$on("updatedTicket", async () => {
      this.tickets.data = [];
      await this.fetchTickets();
    });
  },
  mounted() {},
  destroy() {
    this.$EventBus.$off("updatedTicket");
  },
};
</script>

<style lang="scss">
.dashboard-heading {
  margin-bottom: 8px !important;
}

.dashboard-notices-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  color: $primary;
  background: #fff;
  border: 1px solid #dce7ea;
  border-radius: 50%;
  cursor: pointer;

  &::after {
    position: absolute;
    top: 50%;
    right: calc(100% + 8px);
    z-index: 999;
    padding: 0.35rem 0.55rem;
    color: #fff;
    font-size: 0.68rem;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    content: attr(data-tooltip);
    background: #444;
    border-radius: 4px;
    opacity: 0;
    pointer-events: none;
    transform: translateY(-50%);
    transition: opacity 0.15s ease;
  }

  &:hover,
  &:focus {
    color: #fff;
    background: $primary;
    border-color: $primary;
    outline: none;

    &::after {
      opacity: 1;
    }
  }
}

.dashboard-notices-dot {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 9px;
  height: 9px;
  background: #48c78e;
  border: 2px solid #fff;
  border-radius: 50%;
}

.dashboard-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
  margin-bottom: 22px;
}

.summary-card {
  display: flex;
  align-items: center;
  gap: 13px;
  min-height: 82px;
  padding: 14px 16px;
  color: #424242;
  background: #fff;
  border: 1px solid #edf1f3;
  border-radius: 12px;
  box-shadow: 0 5px 16px rgba(23, 36, 41, 0.05);
  transition: border-color 0.18s ease, background-color 0.18s ease;

  &:hover,
  &:focus {
    color: $primary;
    background: #f8fcfd;
    border-color: #b9e2ea;
  }
}

.summary-icon {
  display: inline-flex;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  color: $primary;
  background: #e7f4f7;
  border-radius: 50%;

  i {
    font-size: 18px;
  }
}

.summary-copy {
  display: flex;
  flex: 1;
  flex-direction: column;

  strong {
    color: $primary;
    font-size: 22px;
    line-height: 1;
  }

  small {
    margin-top: 5px;
    color: #68747a;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
  }
}

.summary-arrow {
  color: #a6b0b5;
  font-size: 22px;
  line-height: 1;
}

.dashboard-widgets {
  align-items: flex-start;
  gap: 14px;
  margin: 0 0 18px !important;
}

.dashboard-widget {
  max-height: 430px;
  padding: 18px !important;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #edf1f3;
  border-radius: 12px;

  h2.title.is-4 {
    margin-bottom: 14px;
    color: $primary !important;
    font-size: 14px !important;
    font-weight: 700;
    text-transform: uppercase;
  }
}

.dashboard-view-all {
  display: block;
  padding: 9px;
  color: $primary;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  border-radius: 99px;

  &:hover {
    background: #e7f4f7;
  }
}

.button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  //justify-content: space-between;
}

.button {
  color: #00758f; /* Color de texto celeste */
  border: 1px solid #ffc107; /* Borde amarillo */
  padding: 5px 10px; /* Espaciado interno para los botones */
  margin: 0; /* Margen entre los botones */
  text-decoration: none; /* Eliminar subrayado enlaces */
}

.button-link:hover {
  background-color: #ffc107; /* Color de fondo amarillo al pasar el mouse */
  color: #00758f; /* Color de texto celeste al pasar el mouse */
}
#tickets {
  position: relative;
  height: 100vh;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  center {
    text-transform: uppercase;
    font-weight: 500;
    color: $grey-light;
  }
  .columns:last-child {
    height: auto;
  }
  .customSelect {
    .select,
    select {
      width: 100%;
      display: block;
    }
  }
  .column h2.title.is-4 {
    color: grey; /* Color gris claro */
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  #tickets {
    height: auto;
    min-height: 100%;
    padding: 18px 14px;
  }

  .dashboard-summary {
    grid-template-columns: 1fr;
  }

  .dashboard-widgets {
    display: block;
  }

  .dashboard-widget {
    margin-bottom: 14px;
  }
}
</style>
